module.exports = __webpack_public_path__ + "img/1440.53c8e1f6.jpg";